import angular from 'angular';

import queryBuilderComponent from './query-builder/query-builder.component';
import queryBuilderNodeNameComponent from './query-builder-node-name/query-builder-node-name.component';
import queryBuilderChildrenComponent from './query-builder-children/query-builder-children.component';
import queryBuilderChildrenGroupComponent from './query-builder-children-group/query-builder-children-group.component';
import queryClassesComponent from './query-classes/query-classes.component';
import queryClassesTreeComponent from './query-classes-tree/query-classes-tree.component';
import queryColumnsComponent from './query-columns/query-columns.component';
import queryConditionComponent from './query-condition/query-condition.component';
import queryEditorComponent from './query-editor/query-editor.component';
import queryHomeComponent from './query-home/query-home.component';
import queryRuleComponent from './query-rule/query-rule.component';
import queryRuleHavingComponent from './query-rule-having/query-rule-having.component';
import queryRuleOperatorComponent from './query-rule-operator/query-rule-operator.component';
import queryRuleValueComponent from './query-rule-value/query-rule-value.component';
import queryRuleVariableComponent from './query-rule-variable/query-rule-variable.component';
import queryRunButtonComponent from './query-run-button/query-run-button.component';
import querySelectPathComponent from './query-select-path/query-select-path.component';
import queryToolbarComponent from './query-toolbar/query-toolbar.component';
import queryVariablesComponent from './query-variables/query-variables.component';
import queryVariablesFormComponent from './query-variables-form/query-variables-form.component';

export default angular
	.module('app.query', [])
	.component('queryBuilder', queryBuilderComponent)
	.component('queryBuilderNodeName', queryBuilderNodeNameComponent)
	.component('queryBuilderChildren', queryBuilderChildrenComponent)
	.component('queryBuilderChildrenGroup', queryBuilderChildrenGroupComponent)
	.component('queryClasses', queryClassesComponent)
	.component('queryClassesTree', queryClassesTreeComponent)
	.component('queryColumns', queryColumnsComponent)
	.component('queryCondition', queryConditionComponent)
	.component('queryEditor', queryEditorComponent)
	.component('queryHome', queryHomeComponent)
	.component('queryRule', queryRuleComponent)
	.component('queryRuleHaving', queryRuleHavingComponent)
	.component('queryRuleOperator', queryRuleOperatorComponent)
	.component('queryRuleValue', queryRuleValueComponent)
	.component('queryRuleVariable', queryRuleVariableComponent)
	.component('queryRunButton', queryRunButtonComponent)
	.component('querySelectPath', querySelectPathComponent)
	.component('queryToolbar', queryToolbarComponent)
	.component('queryVariables', queryVariablesComponent)
	.component('queryVariablesForm', queryVariablesFormComponent)
	.name;
